import Pagenation from "components/Pagenation";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import * as dbmsApi from "../../apis/DbmsApi";
import { apiWrapper } from "apis/CommonApi";
import { API_HOST } from "Constants";

//사업자 관리
export default function BusinessManagementComponent() {
  const itemsPerPage = 100;
  const [dataSource, setDataSource] = useState([]);
  const [previous, setPrevious] = useState(null);
  const [next, setNext] = useState(null);
  const [page, setPage] = useState(1);
  const [isDelModalOpen, setIsDelModalOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
  const [formData, setFormData] = useState(null);
  const [checkedIds, setCheckedIds] = useState([]);

  useEffect(() => {
    setFormDataProperty("id", "");
    setFormDataProperty("businessNumber", "");
    setFormDataProperty("managerName", "");
    setFormDataProperty("businessName", "");
    setFormDataProperty("contactNumber", "");
    setFormDataProperty("representativeName", "");
    setFormDataProperty("email", "");
    setFormDataProperty("address", "");
    setFormDataProperty("ciLogoImageSrc", "");
    setFormDataProperty("ciLogoImageFile", null);
    setFormDataProperty("ciLogoImageFilename", "");

    getData(1);
  }, []);

  //page: 1베이스
  const getData = (page, url = null) => {
    apiWrapper(async () => {
      let result;
      if (url !== null) {
        result = await dbmsApi.getBusinessListByUrl(url);
      } else {
        result = await dbmsApi.getBusinessList(
          '',
          page,
          itemsPerPage
        );
      }

      const { status, data } = result;
      if (status === true) {
        setDataSource(data);

        setPrevious(data.previous);
        setNext(data.next);
        setPage(page);
      } else {
        alert(`${data}`);
      }
    });
  };

  const setFormDataProperty = (name, value) => {
    setFormData((currentFormData) => {
      const nextFormData = {
        ...currentFormData,
        [name]: value,
      };
      //console.log(nextFormData);
      return nextFormData;
    });
  };

  const onChange = (e) => {
    if (e.target.type === 'file') {
      const files = e.target.files;
      if (files.length > 0) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const image = e.target.result;
          setFormDataProperty("ciLogoImageSrc", image);
          setFormDataProperty("ciLogoImageFile", files[0]);
          setFormDataProperty("ciLogoImageFilename", files[0].name);
        };
        reader.readAsDataURL(files[0]);
      }
    } else {
      let name = e.target.name;
      let value = e.target.value;
      setFormDataProperty(name, value);
    }
  };

  const openModal = async (data) => {
    if (data) {
      setFormDataProperty("id", data.id);
      setFormDataProperty("businessNumber", data.businessNumber);
      setFormDataProperty("managerName", data.managerName);
      setFormDataProperty("businessName", data.businessName);
      setFormDataProperty("contactNumber", data.contactNumber);
      setFormDataProperty("representativeName", data.representativeName);
      setFormDataProperty("email", data.email);
      setFormDataProperty("address", data.address);
      setFormDataProperty("ciLogoImageSrc", API_HOST + data.ciLogoImage);
      setFormDataProperty("ciLogoImageFilename", data.ciLogoImageFilename);

      //이미지 URL -> Blob 변환
      try {
        const response = await fetch(API_HOST + data.ciLogoImage);
        if (!response.ok) {
          throw new Error(`${response.status}`);
        }

        const blob = await response.blob();
        const file = new File([blob], data.ciLogoImageFilename, { type: blob.type });
        setFormDataProperty("ciLogoImageFile", file);
      } catch (error) {
        console.error("이미지 URL을 Blob 객체로 변환 실패 : ", error)
      }
    } else {
      setFormDataProperty("id", "");
      setFormDataProperty("businessNumber", "");
      setFormDataProperty("managerName", "");
      setFormDataProperty("businessName", "");
      setFormDataProperty("contactNumber", "");
      setFormDataProperty("representativeName", "");
      setFormDataProperty("email", "");
      setFormDataProperty("address", "");
      setFormDataProperty("ciLogoImageSrc", "");
      setFormDataProperty("ciLogoImageFile", null);
      setFormDataProperty("ciLogoImageFilename", "");
    }

    setIsModalOpen(true);
    setTimeout(() => {
      const modalContent = document.querySelector(".modal_content");
      if (modalContent) {
        modalContent.style.transform = "translateX(0)";
      }
    }, 10);
  }

  const closeModal = () => {
    const modalContent = document.querySelector(".modal_content");
    if (modalContent) {
      modalContent.style.transform = "translateX(100%)";
    }
    setTimeout(() => {
      setIsModalOpen(false);
    }, 500);
  }

  const openPreviewModal = () => {
    setIsPreviewModalOpen(true);
  }

  const closePreviewModal = () => {
    setIsPreviewModalOpen(false);
  }

  const openDelModal = () => {
    if (checkedIds.length < 1) {
      alert("1개 이상 선택해주세요.");
    } else {
      setIsDelModalOpen(true);
    }
  }

  const closeDelModal = () => {
    setIsDelModalOpen(false);
  }

  const handleSave = (e) => {
    e.preventDefault();

    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
    } else if (checkValid() === false) {
      e.stopPropagation();
    } else {
      apiWrapper(async () => {
        const requestBody = new FormData();
        requestBody.append("ciLogoImage", formData.ciLogoImageFile);
        requestBody.append("payload",
          JSON.stringify({
            businessNumber: formData.businessNumber,
            businessName: formData.businessName,
            representativeName: formData.representativeName,
            address: formData.address,
            managerName: formData.managerName,
            contactNumber: formData.contactNumber,
            email: formData.email,
          }));

        let result;
        if (typeof formData.id !== 'undefined' && formData.id !== "") {
          result = await dbmsApi.updateBusiness(formData.id, requestBody);
        } else {
          result = await dbmsApi.addBusiness(requestBody);
        }

        const { status, data } = result;
        if (status === true) {
          alert(`저장을 완료하였습니다.`);

          //성공 시 새로고침
          closeModal();
          getData(page);
        } else {
          alert(`${data}`)
        }
      });
    }
  }

  const checkValid = () => {
    if (formData.ciLogoImageFile === null) {
      alert(`CI logo 파일을 선택해주세요.`);
      return false;
    }
    return true;
  }

  const handleCheckAll = (e) => {
    if (e.target.checked) {
      setCheckedIds(dataSource.results.map((a) => a.id));
    } else {
      setCheckedIds([]);
    }
  };

  const handleChangeCheck = (e, id) => {
    if (e.target.checked) {
      setCheckedIds([...checkedIds, id]);
    } else {
      setCheckedIds(checkedIds.filter((a) => a !== id));
    }
  };

  const handleDelete = () => {
    apiWrapper(async () => {
      const { status, data } = await dbmsApi.bulkDeleteBusiness(checkedIds);
      alert(`${data}`)

      //삭제 성공 시 새로고침
      if (status === true) {
        closeDelModal();
        getData(page)
      }
    });
  }

  const handleDeactivate = () => {
    if (window.confirm("사용중지하시겠습니까?")) {
      apiWrapper(async () => {
        const { status, data } = await dbmsApi.bulkDeactivateBusiness(checkedIds);
        alert(`${data}`)

        //사용중지 성공 시 새로고침
        if (status === true) {
          getData(page);
        }
      });
    }
  }

  const handlePageArrowClick = (page, isNext) => {
    let url = null;
    if (isNext === false) {
      url = previous;
    } else {
      url = next;
    }

    getData(page, url);
  }

  return (
    <>
      <div class="viewBoard viewDBMSBoard">
        <div class="top_board pc">
          <p class="title_board">사업자 관리</p>
        </div>
        <div class="top_board mb">
          <div class="wrap_logo">
            {/* <!-- <img src="" alt="" class="img_logo"> --> */}
          </div>
          <div class="header_dept">
            <p class="user">COWORKER</p>
            <div class="wrap_contr">
              <Link class="set_contr" to="">
                {/* <img src="/images/my_btn_mb.png" alt=""> */}
              </Link>
            </div>
          </div>
        </div>
        <div class="top_board navi_board mb">
          <Link class="wrap_navi" to="/">
            <p class="title_navi">사업자 관리</p>
          </Link>

          <div class="wrap_right mb">
            <Link class="btn_page_left" to="/dbmsMenu.html">
              <i class="x-icon"></i>
            </Link>
          </div>
        </div>

        <div class="table_board">
          <table class="admin-table">
            <colgroup>
              <col width="5%" />
              <col width="10%" />
              <col width="14%" />
              <col width="8%" />
              <col width="14%" />
              <col width="20%" />
              <col width="7%" />
              <col width="20%" />
              <col width="14%" />
              <col width="8%" />
            </colgroup>
            <thead class="admin-thead">
              <tr class="admin-tr">
                <th class="admin-th">
                  <input type="checkbox" name="" id="" onChange={handleCheckAll} />
                </th>
                <th class="admin-th">
                  <p>관리순번</p>
                </th>
                <th class="admin-th">
                  <p>사업자번호</p>
                </th>
                <th class="admin-th">
                  <p>상호</p>
                </th>
                <th class="admin-th">
                  <p>대표자</p>
                </th>
                <th class="admin-th">
                  <p>주소</p>
                </th>
                <th class="admin-th">
                  <p>담당자</p>
                </th>
                <th class="admin-th">
                  <p>연락처</p>
                </th>
                <th class="admin-th">
                  <p>이메일</p>
                </th>
                <th class="admin-th">
                  <p>상태</p>
                </th>
              </tr>
            </thead>
            <tbody class="admin-tbody">
              {dataSource.results &&
                dataSource.results.map((item, index) => (
                  <tr class="admin-tr wrap_table_item">
                    <td class="admin-td">
                      <input type="checkbox" id={`check${index}`} checked={checkedIds.includes(item.id)} onChange={(e) => handleChangeCheck(e, item.id)} />
                    </td>
                    <td class="admin-td">
                      <p>{item.id}</p>
                    </td>
                    <td class="admin-td">
                      <p>{item.businessNumber}</p>
                    </td>
                    <td class="admin-td modal-td" onClick={() => openModal(item)}>
                      <p>{item.businessName}</p>
                    </td>
                    <td class="admin-td">
                      <p>{item.representativeName}</p>
                    </td>
                    <td class="admin-td">
                      <p>{item.address}</p>
                    </td>
                    <td class="admin-td">
                      <p>{item.managerName}</p>
                    </td>
                    <td class="admin-td">
                      <p>{item.contactNumber}</p>
                    </td>
                    <td class="admin-td">
                      <p>{item.email}</p>
                    </td>
                    <td class="admin-td">
                      <p>{item.status === true ? "사용" : "사용중지"}</p>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>

        <div class="wrap_controll type-start">
          <div class="wrap_dbms_btn">
            <button class="item_btn registerBtn" onClick={openModal}>신규등록</button>
            <button class="item_btn" onClick={handleDeactivate}>사용중지</button>
            <button class="item_btn" id="deleteBtn" onClick={openDelModal}>삭제</button>
          </div>
          <div id="pagination">
            <Pagenation
              totalItemsCount={dataSource.count}
              itemsPerPage={itemsPerPage}
              selectedPage={page}
              setPage={(value) => setPage(value)}
              handlePageArrowClick={handlePageArrowClick}
            />
          </div>
        </div>

        {/* <!-- 삭제 여부 모달 --> */}
        {isDelModalOpen && (
          <div id="modal" class="modal dbmsDelModal show">
            <div class="modal-content">
              <div class="modal_inner">
                <p class="modal_title">정말로 삭제하시겠습니까?</p>
                <p class="modal_sub">삭제하시면 선택하신 정보는 사라집니다.</p>
                <div class="btn-wrap">
                  <button class="modal_btn" onClick={closeDelModal}>취소</button>
                  <button class="modal_btn del_btn" onClick={handleDelete}>삭제</button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* < !--사업자 정보 --> */}
        {isModalOpen && (
          <div id="modal" class="modal rightModal noticeRightModal open"
            onClick={(e) => {
              if (e.target === e.currentTarget)
                closeModal();
            }}>
            <form class="modal_content" onSubmit={handleSave}>
              <button type="button" class="close_modal" onClick={closeModal}>
                <i class="x-icon close_icon"></i>
              </button>
              <h2>사업자 정보</h2>
              <div class="wrap_detail_cont type2">
                <div class="wrap_detail_item">
                  <p class="title_detail">사업자 번호</p>
                  <div class="detail_box">
                    <input class="readonly_input" type="text" name="businessNumber" value={formData.businessNumber} onChange={onChange} required />
                  </div>
                </div>
                <div class="wrap_detail_item">
                  <p class="title_detail">주 담당자</p>
                  <div class="detail_box">
                    <input class="readonly_input" type="text" name="managerName" value={formData.managerName} onChange={onChange} required />
                  </div>
                </div>
                <div class="wrap_detail_item ">
                  <p class="title_detail">상호</p>
                  <div class="detail_box">
                    <input class="readonly_input" type="text" name="businessName" value={formData.businessName} onChange={onChange} required />
                  </div>
                </div>
                <div class="wrap_detail_item">
                  <p class="title_detail">연락처</p>
                  <div class="detail_box">
                    <input class="readonly_input" type="text" name="contactNumber" value={formData.contactNumber} onChange={onChange} required />
                  </div>
                </div>
                <div class="wrap_detail_item">
                  <p class="title_detail">대표자</p>
                  <div class="detail_box">
                    <input class="readonly_input" type="text" name="representativeName" value={formData.representativeName} onChange={onChange} required />
                  </div>
                </div>
                <div class="wrap_detail_item">
                  <p class="title_detail">이메일</p>
                  <div class="detail_box">
                    <input class="readonly_input" type="text" name="email" value={formData.email} onChange={onChange} required />
                  </div>
                </div>
                <div class="wrap_detail_item">
                  <p class="title_detail">주소</p>
                  <div class="detail_box">
                    <input class="readonly_input" type="text" name="address" value={formData.address} onChange={onChange} required />
                  </div>
                </div>
                <div class="wrap_detail_item">
                  <p class="title_detail">CI logo 파일</p>
                  <div class="detail_box detail_btn_box detail_file_box">
                    <label class="black_line_btn">
                      찾기
                      <input type="file" accept=".png, .jpg, .jpeg" name="ciLogoImage" onChange={onChange} />
                    </label>
                    <div class="file-list-wrap" onClick={openPreviewModal}>
                      <p>{formData.ciLogoImageFilename}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="wrap_controll type-start">
                <button type="submit" class="btn_dark btn_save">저장</button>
              </div>
            </form>
          </div>
        )}

        <div class="previewModal" id="previewModal" style={{ display: isPreviewModalOpen ? "block" : "none" }}>
          <div class="modal-content">
            <button type="button" class="close_modal" onClick={closePreviewModal}>
              <i class="x-icon close_icon"></i>
            </button>
            <div class="img-wrap">
              <img
                id="previewImage"
                src={formData && formData.ciLogoImageSrc}
                alt="" />
            </div>
          </div>
        </div>

      </div >
    </>
  );
}
